module.exports = __webpack_public_path__ + "8fce18c178738c3ec320b94b9433624f.pdf";